import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import Breadcrumb from "../../components/BreadCumbsLinks";
import Category from "../../components/category/category";
import UseGeneral from "../../hooks/useGeneral";
import { ThreeDots } from "react-loader-spinner";

const CategoryLatout = () => {
  const { language } = UseGeneral();
  const [pageLoading, setPageLoading] = useState(false);
  const [favs, setFavs] = useState([]);
  const breadCrumbsLinks = [
    { name: language != "ar" ? "Home" : "الصفحة الرئيسية", path: "/" },
    {
      name: language != "ar" ? "Categories" : "الفئات",
      path: "/Categories",
      active: true,
    },
  ];

  const getUserFavs = () => {
    setPageLoading(true);
    Axios({
      url: BASE_URL + "categories/get_all",
      method: "GET",
    })
      .then((res) => {
        ;
        if (res.message == "Sission Ended Login Again") {
          // toast.error(res.message);
        } else {
          toast.error(res.message);
        }
        if (res.status == "success") {
          setFavs(res.result);
        } else {
          toast.error(res.message);
        }
      })
      .finally(() => {
        setPageLoading(false);
      });
  };
  useEffect(() => {
    getUserFavs();
  }, []);
  return (
    <>
      <div className="rowDiv homeCategories">
        <Breadcrumb links={breadCrumbsLinks} />
      </div>
      <div className="rowDiv homeCategories">
        {pageLoading ? (
          <ThreeDots />
         
        ) : (
          favs?.map((item) => {
            if (item?.image)
              return (
                <Category
                  id={item?.id}
                  image={item?.image}
                  title={language == "ar" ? item?.title_ar : item?.title_en}
                  color={item?.color}
                />
              );
          })
        )}
      </div>
    </>
  );
};

export default CategoryLatout;
